import { takeLatest } from 'redux-saga/effects'
import { RealtimeActions } from './realtime.actions'
import {
  initRealtimeSyncEffect,
  acceptPushNudgeEffect,
  watchRemoteChangesEffect,
  watchPermissionChangesEffect,
  syncDueDatesEffect
} from './realtime.effects'

function* initRealtimeSyncSaga() {
  yield takeLatest(RealtimeActions.INIT_REALTIME_SYNC, initRealtimeSyncEffect)
}

function* acceptPushNudgeSaga() {
  yield takeLatest(RealtimeActions.ACCEPT_PUSH_NUDGE, acceptPushNudgeEffect)
}

export const RealtimeWatcher = [
  initRealtimeSyncSaga(),
  acceptPushNudgeSaga(),
  // Long-running: merges FCM/SW-message/visibility triggers into delta refreshes.
  watchRemoteChangesEffect(),
  // Long-running: mirrors browser permission changes (e.g. unblock via site settings).
  watchPermissionChangesEffect(),
  // Long-running: periodic due-date re-sync (dues don't ride the transaction push).
  syncDueDatesEffect()
]
